/**
 * Shared permissions for the test-jwt plugin.
 *
 * @packageDocumentation
 */

import { createPermission } from '@backstage/plugin-permission-common';

export const testJwtCreatePermission = createPermission({
  name: 'test-jwt.create',
  attributes: { action: 'create' },
});

export const testJwtLookupPermission = createPermission({
  name: 'test-jwt.lookup',
  attributes: { action: 'read' },
});

export const testJwtPermissions = [
  testJwtCreatePermission,
  testJwtLookupPermission,
];
